import React, { useState, useRef, useEffect } from 'react'
import api from '../../services/api'
import { toast } from 'react-toastify'
import { FaFileUpload } from 'react-icons/fa'
import { useDispatch, useSelector } from 'react-redux'
import { set_handle_posts } from '../../store/setting/actions'
import { Link } from 'react-router-dom'
import Plyr from "plyr-react"
import "plyr-react/plyr.css"
import '../CreatePost/css.css'
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import ImageResize from 'quill-image-resize';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../Post/style-carousel.css';
import Cookies from 'js-cookie'
import EmojiPicker from 'emoji-picker-react'
import { Dropdown, Button, Modal, CloseButton, Form, Col } from 'react-bootstrap'

import user1 from '../../assets/images/user/1.jpg'
import 'quill-mention/dist/quill.mention.css';
import { Mention, MentionBlot } from "quill-mention";

Quill.register({ "blots/mention": MentionBlot, "modules/mention": Mention });
Quill.register('modules/imageResize', ImageResize);

const CreatePost = (props) => {
  const dispatch = useDispatch()
  const [show, setShow] = useState(false)
  const [text, setText] = useState('')
  const [newMedia, setNewMedia] = useState([]);
  const [showMediaInput, setShowMediaInput] = useState(false)
  const [showSpinner, setShowSpinner] = useState(false)
  const [privacy, setPrivacy] = useState('public')
  const [important, setImportant] = useState(0)
  const [dataImportant, setDataImportant] = useState('')
  const [horaImportant, setHoraImportant] = useState('')
  const [userPermissions, setUserPermissions] = useState([])
  const [showPicker, setShowPicker] = useState(false)
  const handlePosts = useSelector((state) => state.setting.setting.handle_posts)
  const logged_user = Cookies.get('userId')

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  function convertMentionsToCustomFormat(html) {
    const div = document.createElement('div');
    div.innerHTML = html;

    const mentions = div.querySelectorAll('span.mention');

    mentions.forEach(span => {
      const name = span.dataset.value;
      const id = span.dataset.id;

      const formatted = `{@}[${name}](${id})`;

      const textNode = document.createTextNode(formatted);
      span.parentNode.replaceChild(textNode, span);
    });

    return div.innerHTML;
  }

  const handleEmojiSelect = (emojiObject, event) => {
    const quill = quillInstance.current;

    if (!quill) {
      console.error('Erro: Instância do Quill não disponível para inserir emoji.');
      return;
    }

    const emojiToInsert = String(emojiObject.emoji || '');

    if (emojiToInsert === '') {
      console.warn('Atenção: Emoji selecionado está vazio ou inválido. Não será inserido.');
      return;
    }

    try {
      let currentText = quill.getText();
      
      const editorLength = quill.getLength();
      let insertionIndex = editorLength;

      if (currentText.endsWith('\n')) {
        insertionIndex = editorLength - 1;

        if (insertionIndex < 0) {
            insertionIndex = 0;
        }
      }
      
      quill.insertText(insertionIndex, emojiToInsert);
      
      quill.setSelection(insertionIndex + emojiToInsert.length);

      setShowPicker(false);
    } catch (error) {
      console.error("Erro ao inserir emoji no Quill:", error);
      console.error("Detalhes do erro:", error.message, error.stack);
    }
  };

  const handleSubmit = async (e) => {

    const toastId = toast.loading('Incluindo mídias, por favor aguarde...');

    e.preventDefault();
    setShowSpinner(true);

    if (!text.trim() && newMedia.length === 0) {
      setShowSpinner(false);
      toast.error('Por favor escreva um texto ou selecione uma mídia para publicar.', { autoClose: 3000 });
      return;
    }

    const formData = new FormData();
    formData.append('text', text);
    formData.append('privacy', privacy);

    if (important) {
      formData.append('data_important', dataImportant);
      formData.append('hora_important', horaImportant);
      formData.append('privacy', 'public');
      formData.append('important', '1');
    } else {
      formData.append('important', '0');
    }

    newMedia.forEach((item, index) => {
      if (item.file) {
        formData.append(`media[${index}]`, item.file);
      } else {
        formData.append(`media[${index}]`, item.url);
      }
    });

    if (props.group_id) {
      formData.append('group_id', props.group_id);
    }

    try {
      await api.post('/api/posts/store', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      setShowSpinner(false);
      setText('');
      setNewMedia([]);
      setImportant(0);
      setDataImportant('');
      setHoraImportant('');
      quillInstance.current.root.innerHTML = '';

      dispatch(set_handle_posts(!handlePosts));

      toast.update(toastId, {
        render: 'Postagem criada com sucesso!',
        type: 'success',
        isLoading: false,
        autoClose: 3000,
      });

    } catch (error) {
      setShowSpinner(false);
      toast.error('Erro ao publicar postagem.', { autoClose: 3000 });
      console.error('Erro ao criar postagem:', error.response?.data || error.message);
    }
  };

  const handleMediaClick = () => {
    setShowMediaInput(!showMediaInput)
  }

  const getUserPermisssions = async () => {
    try {
      const [userPermissionsResponse] = await Promise.all([
          api.get(`/api/permissions/user/${logged_user}`)
      ])

      setUserPermissions(userPermissionsResponse.data.userPermissions)
    } catch (error) {
      console.error('Erro ao buscar permissões do usuário:', error)
    }
  }

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files); 
    const newMidia = files.map((file) => ({
      file,
      type: file.type.split('/')[0], 
      url: URL.createObjectURL(file), 
    }));
    setNewMedia((prevMedia) => [...prevMedia, ...newMidia]);
    setShowMediaInput(false);
  };

  const removeMedia = (index) => {
    setNewMedia((prevMedia) => prevMedia.filter((_, i) => i !== index));
  };

  const handleImageInsert = (file = null) => {
    const quill = quillInstance.current;
    const range = quill.getSelection();

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        quill.insertEmbed(range.index, 'image', reader.result);
      };
      reader.readAsDataURL(file);

      setNewMedia((prevMidia) => [
        ...prevMidia,
        { file, type: 'image', url: URL.createObjectURL(file) },
      ]);
    } else {
      const input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', 'image/*,video/*');
      input.click();

      input.onchange = () => {
        if (input.files.length > 0) {
          handleImageInsert(input.files[0]);
        }
      };
    }
  };

  const removeImages = () => {
    const images = quillInstance.current.root.querySelectorAll('img');
    images.forEach(img => img.remove());
  };

  const editorRef = useRef(null);
  const quillInstance = useRef(null);

  useEffect(() => {
    if (!quillInstance.current) {
      quillInstance.current = new Quill(editorRef.current, {
        theme: "snow",
        placeholder: 'Escreva algo e compartilhe com seus amigos...',
        modules: {
          mention: {
            allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
            mentionDenotationChars: ["@"],
            source: async function(searchTerm, renderList, mentionChar) {
              let values;

              const response = await api.get(`/api/get_suggestions_web`);
              const { suggestions } = response.data;

              values = suggestions;

              if (searchTerm.length === 0) {
                renderList(values, searchTerm);
              } else {
                const matches = [];
                for (let i = 0; i < values.length; i++)
                  if (
                    ~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())
                  )
                    matches.push(values[i]);
                renderList(matches, searchTerm);
              }
            }
          },
          toolbar: [
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link"],
            ["clean"],
          ],
          clipboard: {
            matcheVisual: false,
            matchers: [
              [
                Node.TEXT_NODE,
                (node, delta) => {
                  const text = node.data;
                  if (text.match(/(https?:\/\/.*\.(?:png|jpg|jpeg|gif|svg))/i)) {
                    return { ops: [] };
                  }
                  return delta;
                },
              ],
            ],
          },
        },
      });

      quillInstance.current.on("text-change", () => {
        const editorHTML = quillInstance.current.root.innerHTML;
        const customFormatted = convertMentionsToCustomFormat(editorHTML);

        setText(customFormatted);
        removeImages();
      });

      quillInstance.current.root.addEventListener("paste", handlePaste);
    }
  }, []);

  useEffect(() => {
    getUserPermisssions()
  }, [])

  const isValidUrl = (url) => {
    try {
      const parsedUrl = new URL(url);
      return parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:";
    } catch (error) {
      return false;
    }
  };

  const handlePaste = (e) => {
    const clipboardData = e.clipboardData || window.clipboardData;
    const items = clipboardData.items;

    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.type.indexOf("image") !== -1) {
        e.preventDefault();
        const file = item.getAsFile();
        if (file) {
          const reader = new FileReader();
          reader.onload = () => {
            setNewMedia((prevMidia) => [
              ...prevMidia,
              { file, type: 'image', url: reader.result },
            ]);
          };
          reader.readAsDataURL(file);
        }
        return;
      }
    }

    const text = clipboardData.getData("text");
    if (text.match(/\.(jpeg|jpg|gif|png|webp)$/i)) {
      e.preventDefault();
      if (isValidUrl(text)) {
        setNewMedia((prevMidia) => [
          ...prevMidia,
          { file: null, type: 'image', url: text },
        ]);
      } else {
        toast.error('URL inválida. Por favor, insira uma URL válida.', { autoClose: 3000 });
      }
    }
  };

  const settings = {
    dots: false,
    infinite: newMedia.length > 1, 
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
  };

  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = newMedia.length;

  const MAX_INDICATORS = Math.max(newMedia.length);

  const getVisibleIndicators = (total, current) => {
    if (total <= MAX_INDICATORS) return Array.from({ length: total }, (_, i) => i);

    const halfMax = Math.floor(MAX_INDICATORS / 2);
    let start = Math.max(0, current - halfMax);
    let end = Math.min(total, start + MAX_INDICATORS);

    if (end - start < MAX_INDICATORS) start = Math.max(0, end - MAX_INDICATORS);

    return Array.from({ length: end - start }, (_, i) => i + start);
  };

  const getIndicatorStyle = (index, current) => {
    const distance = Math.abs(current - index);

    if (distance === 0) return 'large';
    if (distance === 1) return 'medium';
    if (distance === 2) return 'small';
    return 'tiny';
  };

  return (
    <>
      <div id='post-modal-data' className={`card ${props.class}`}>
        <div className='card-header d-flex justify-content-between border-bottom'>
          <div className='header-title'>
            <h5 className='card-title'>Adicionar Post</h5>
          </div>
          <Dropdown >
            <Dropdown.Toggle className='lh-1' id='post-option' as='div' bsPrefix=' '>
              {/* <span className='material-symbols-outlined'>more_horiz</span> */}
            </Dropdown.Toggle>
            <Dropdown.Menu
              variant='right'
              aria-labelledby='post-option'
              style={{ position: 'absolute', inset: 'auto auto 0px 0px', margin: '0px', transform: 'translate(0px, -27px)' }}
            >
              <Dropdown.Item
                href='#'
                onClick={handleShow}
              >
                Check in
              </Dropdown.Item>
              <Dropdown.Item
                href='#'
                onClick={handleShow}
              >
                Live Video
              </Dropdown.Item>
              <Dropdown.Item
                href='#'
                onClick={handleShow}
              >
                GIF
              </Dropdown.Item>
              <Dropdown.Item
                href='#'
                onClick={handleShow}
              >
                Watch Party
              </Dropdown.Item>
              <Dropdown.Item
                href='#'
                onClick={handleShow}
              >
                Play with Friend
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className='card-body'>
          <div className='d-flex align-items-center mb-5'>
            <form className='post-text w-100'>

              <div ref={editorRef} ></div>

              {newMedia.length > 0 && (
                <div className="user-post mt-4 live-container">
                  <Slider {...settings}>
                    {newMedia.map((item, index) => (
                      <div key={index} className="position-relative align-items-center justify-content-center d-flex">
                        {item.type === 'image' ? (
                          <img
                            src={URL.createObjectURL(item.file)}
                            alt="Imagem escolhida"
                            style={{ maxWidth: '100%', maxHeight: '300px', objectFit: 'cover' }}
                          />
                        ) : item.type === 'video' ? (
                          <div className="d-flex" style={{ maxWidth: '100%', maxHeight: '300px', objectFit: 'cover' }}>
                            <Plyr
                              source={{
                                type: 'video',
                                sources: [{ src: URL.createObjectURL(item.file), type: 'video/mp4' }],
                              }}
                            />
                          </div>
                        ) : null}
                        <button
                          onClick={(e) => {
                            removeMedia(index);
                            e.preventDefault();
                          }}
                          className='removeButton'
                        >
                          <span
                            className="material-symbols-outlined"
                            style={{ color: '#fff', fontSize: '20px' }}
                          >
                            delete
                          </span>
                        </button>
                      </div>
                    ))}
                  </Slider>

                  <div className='pageCounter'>
                    <p className='pageCounterText'>
                      {currentSlide + 1}/{newMedia.length}
                    </p>
                  </div>

                  {totalSlides > 1 && (
                    <div className="share-media-slider-dots mt-4">
                      {getVisibleIndicators(totalSlides, currentSlide).map((index) => (
                        <div
                          key={index}
                          className={`share-media-slider-dot-item ${getIndicatorStyle(
                            index,
                            currentSlide
                          )} ${currentSlide === index ? 'active' : ''}`}
                        >
                          <button className="share-media-slider-dot-button" />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {showMediaInput && (
                <div className="upload-area mt-3 position-relative" style={{ border: '1px solid #ccc', padding: '20px', borderRadius: '5px', textAlign: 'center' }}>
                  <CloseButton
                    onClick={handleMediaClick}
                    style={{ zIndex: 99, position: 'absolute', top: '10px', right: '10px', color: '#ff0000', backgroundColor: '#fff' }}
                  />
                  <FaFileUpload size={48} style={{ color: '#ccc' }} />
                  <p className="mt-2">Adicionar Fotos/Vídeos</p>
                  <p className="text-muted">ou arraste e solte</p>
                  <Form.Control
                    multiple
                    type="file"
                    accept="image/jpeg, image/png, image/gif, image/webp, video/*"
                    onChange={handleFileUpload}
                    className="position-absolute w-100 h-100 opacity-0"
                    style={{ top: 0, left: 0, cursor: 'pointer' }}
                  />
                </div>
              )}

            </form>
          </div>
        </div>
        <div className='card-body bg-primary-subtle rounded-bottom-3'>
          <div className='d-flex align-items-center justify-content-between flex-wrap gap-3'>
            <div className='create-post-data'>
              <ul className='list-inline m-0 p-0 d-flex align-items-center gap-4'>
                <li className="icon-item">
                  <Link to='#' className='text-body' onClick={handleMediaClick}>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='18'
                      height='16'
                      viewBox='0 0 18 16'
                      fill='none'
                      style={{ verticalAlign: 'middle' }} // Alinha verticalmente o SVG
                    >
                      <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M11.5334 1.3761C12.3751 1.7111 12.6326 2.87776 12.9767 3.25276C13.3209 3.62776 13.8134 3.75526 14.0859 3.75526C15.5342 3.75526 16.7084 4.92943 16.7084 6.37693V11.2061C16.7084 13.1478 15.1334 14.7228 13.1917 14.7228H4.80841C2.86591 14.7228 1.29175 13.1478 1.29175 11.2061V6.37693C1.29175 4.92943 2.46591 3.75526 3.91425 3.75526C4.18591 3.75526 4.67841 3.62776 5.02341 3.25276C5.36758 2.87776 5.62425 1.7111 6.46591 1.3761C7.30841 1.0411 10.6917 1.0411 11.5334 1.3761Z'
                        stroke='currentColor'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                      <path
                        d='M13.5794 5.91667H13.5869'
                        stroke='currentColor'
                        strokeWidth='2'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                      <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M11.6489 8.94C11.6489 7.47667 10.4631 6.29083 8.99975 6.29083C7.53642 6.29083 6.35059 7.47667 6.35059 8.94C6.35059 10.4033 7.53642 11.5892 8.99975 11.5892C10.4631 11.5892 11.6489 10.4033 11.6489 8.94Z'
                        stroke='currentColor'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                    </svg>
                  </Link>
                </li>

                <li className="icon-item">
                  <Link to='#' className='text-body' onClick={(e) => {
                    e.preventDefault();
                    setShowPicker((val) => !val);
                  }}>
                    <svg
                      className='icon-24'
                      width='18'
                      height='16'
                      viewBox='0 0 24 25'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <g clipPath='url(#clip0_156_599)'>
                        <path
                          d='M20.4853 4.01473C18.2188 1.74823 15.2053 0.5 12 0.5C8.79469 0.5 5.78119 1.74823 3.51473 4.01473C1.24819 6.28119 0 9.29469 0 12.5C0 15.7053 1.24819 18.7188 3.51473 20.9853C5.78119 23.2518 8.79469 24.5 12 24.5C15.2053 24.5 18.2188 23.2518 20.4853 20.9853C22.7518 18.7188 24 15.7053 24 12.5C24 9.29469 22.7518 6.28119 20.4853 4.01473ZM12 23.0714C6.17091 23.0714 1.42856 18.3291 1.42856 12.5C1.42856 6.67091 6.17091 1.92856 12 1.92856C17.8291 1.92856 22.5714 6.67091 22.5714 12.5C22.5714 18.3291 17.8291 23.0714 12 23.0714Z'
                          fill='currentcolor'
                        ></path>
                        <path
                          d='M9.40398 9.3309C8.23431 8.16114 6.33104 8.16123 5.16136 9.3309C4.88241 9.60981 4.88241 10.0621 5.16136 10.3411C5.44036 10.62 5.89266 10.62 6.17157 10.3411C6.78432 9.72836 7.78126 9.7284 8.39392 10.3411C8.53342 10.4806 8.71618 10.5503 8.89895 10.5503C9.08171 10.5503 9.26457 10.4806 9.40398 10.3411C9.68293 10.0621 9.68293 9.60986 9.40398 9.3309Z'
                          fill='currentcolor'
                        ></path>
                        <path
                          d='M18.8384 9.3309C17.6688 8.16123 15.7655 8.16114 14.5958 9.3309C14.3169 9.60981 14.3169 10.0621 14.5958 10.3411C14.8748 10.62 15.3271 10.62 15.606 10.3411C16.2187 9.72836 17.2156 9.72831 17.8284 10.3411C17.9679 10.4806 18.1506 10.5503 18.3334 10.5503C18.5162 10.5503 18.699 10.4806 18.8384 10.3411C19.1174 10.0621 19.1174 9.60986 18.8384 9.3309Z'
                          fill='currentcolor'
                        ></path>
                        <path
                          d='M18.3335 13.024H5.6668C5.2723 13.024 4.95251 13.3438 4.95251 13.7383C4.95251 17.6243 8.11409 20.7859 12.0001 20.7859C15.8862 20.7859 19.0477 17.6243 19.0477 13.7383C19.0477 13.3438 18.728 13.024 18.3335 13.024ZM12.0001 19.3573C9.14366 19.3573 6.77816 17.215 6.42626 14.4525H17.574C17.2221 17.215 14.8566 19.3573 12.0001 19.3573Z'
                          fill='currentcolor'
                        ></path>
                      </g>
                      <defs>
                        <clipPath>
                          <rect
                            width='24'
                            height='24'
                            fill='white'
                            transform='translate(0 0.5)'
                          ></rect>
                        </clipPath>
                      </defs>
                    </svg>
                  </Link>
                </li>

                {
                  !props.group_id ? (
                    <li className="icon-item">
                      <Dropdown>
                        <Dropdown.Toggle id='post-option' as='span' >
                          {
                            privacy === 'public' && !important ? (
                              <span className='material-symbols-outlined' style={{ 'fontSize': 'large', 'verticalAlign': 'middle' }}>
                                public
                              </span>
                            ) : privacy === 'friends' ? (
                              <span className='material-symbols-outlined' style={{ 'fontSize': 'large', 'verticalAlign': 'middle' }}>
                                group
                              </span>
                            ) : (
                              <span className='material-symbols-outlined' style={{ 'fontSize': 'large', 'verticalAlign': 'middle' }}>
                                keep
                              </span>
                            )
                          }
                        </Dropdown.Toggle>
                        <Dropdown.Menu className='m-0 p-0'>
                          <Dropdown.Item className=' p-3' to='#' onClick={() => {
                            setPrivacy('public')
                            setImportant(0)
                          }}>
                            <div className='d-flex align-items-top'>
                              <span className='material-symbols-outlined' style={{ 'fontSize': 'large', 'verticalAlign': 'middle' }}>
                                public
                              </span>
                              <div className='data ms-2'>
                                <h6>pública</h6>
                              </div>
                            </div>
                          </Dropdown.Item>

                          <Dropdown.Item className='p-3' to='#' onClick={() => {
                            setPrivacy('friends')
                            setImportant(0)
                          }}>
                            <div className='d-flex align-items-top'>
                              <span className='material-symbols-outlined' style={{ 'fontSize': 'large', 'verticalAlign': 'middle' }}>
                                group
                              </span>
                              <div className='data ms-2'>
                                <h6>amigos</h6>
                              </div>
                            </div>
                          </Dropdown.Item>

                          {
                            userPermissions.some((permission) => permission.name === 'create_important_posts') ? (
                              <Dropdown.Item className='p-3' to='#' onClick={() => {
                                setPrivacy('public')
                                setImportant(1)
                              }}>
                                <div className='d-flex align-items-top'>
                                  <span className='material-symbols-outlined' style={{ 'fontSize': 'large', 'verticalAlign': 'middle' }}>
                                    keep
                                  </span>
                                  <div className='data ms-2'>
                                    <h6>aviso importante</h6>
                                  </div>
                                </div>
                              </Dropdown.Item>
                            ) : ''
                          }
                        </Dropdown.Menu>
                      </Dropdown>
                    </li>
                  ) : ''
                }

                {
                  !props.group_id && important ? (
                    <li className='d-flex' style={{ width: '20rem' }}>
                      <Col md='6' style={{ marginRight: '3px' }}>
                        <Form.Label
                          className='form-label'
                          htmlFor='validationCustom03'
                        >
                          Data limite
                        </Form.Label>
                        <Form.Control className='input-group-edit' placeholder='Data início' type='date' value={dataImportant} onChange={(e) => setDataImportant(e.target.value)} aria-describedby='inputGroupPrepend' id='validationCustom03' required />
                      </Col>

                      <Col md='6' className=''>
                        <Form.Label
                          className='form-label'
                          htmlFor='validationCustom04'
                        >
                          Hora limite
                        </Form.Label>
                        <Form.Control className='input-group-edit' placeholder='Hora início' type='time' value={horaImportant} onChange={(e) => setHoraImportant(e.target.value)} aria-describedby='inputGroupPrepend' id='validationCustom04' required />
                      </Col>
                    </li>
                  ) : ''
                }
              </ul>

            </div>
            <div>
              <ul className='list-inline m-0 p-0 d-flex align-items-center gap-4'>
                <li>
                  <button disabled={showSpinner} type='button' className='btn btn-primary px-4' onClick={(e) => handleSubmit(e)}>
                    {showSpinner ? <div className="spinner-border spinner-border-sm" role="status"></div> : <div className='fw-semibold'>Publicar</div>}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <Modal
          show={show}
          onHide={handleClose}
          centered
          id='custom-post-modal'
        >
          <div className='modal-header d-flex justify-content-between'>
            <h5 className='modal-title' id='post-modalLabel'>
              Create Post
            </h5>
            <Link to='#' className='lh-1' onClick={handleClose}>
              <span className='material-symbols-outlined'>close</span>
            </Link>
          </div>
          <Modal.Body>
            <div className='d-flex align-items-center'>
              <div className='user-img'>
                <img
                  loading='lazy'
                  src={user1}
                  alt='userimg'
                  className='avatar-60 rounded-circle img-fluid'
                />
              </div>
              <form className='post-text ms-3 w-100 '>
                <input
                  type='text'
                  className='form-control rounded'
                  placeholder='Write something here...'
                  style={{ border: 'none' }}
                />
              </form>
            </div>
            <hr />
            <ul className='d-flex flex-wrap align-items-center list-inline m-0 p-0'>
              <li className='col-md-6 mb-3'>
                <div className='bg-primary-subtle rounded p-2 pointer me-3'>
                  <Link to='#' className='custom-link-color d-inline-block fw-medium text-body'>
                    <span className='material-symbols-outlined align-middle font-size-20 me-1'>
                      add_a_photo
                    </span>{' '}
                    Photo/Video
                  </Link>
                </div>
              </li>
              <li className='col-md-6 mb-3'>
                <div className='bg-primary-subtle rounded p-2 pointer me-3'>
                  <Link to='#' className='custom-link-color d-inline-block fw-medium text-body'>
                    <span className='material-symbols-outlined align-middle font-size-20 me-1'>
                      group
                    </span>{' '}
                    Tag Friend
                  </Link>
                </div>
              </li>
              <li className='col-md-6 mb-3'>
                <div className='bg-primary-subtle rounded p-2 pointer me-3'>
                  <Link to='#' className='custom-link-color d-inline-block fw-medium text-body'>
                    <span className='material-symbols-outlined align-middle font-size-20 me-1'>
                      sentiment_satisfied
                    </span>{' '}
                    Feeling/Activity
                  </Link>
                </div>
              </li>
              <li className='col-md-6 mb-3'>
                <div className='bg-primary-subtle rounded p-2 pointer me-3'>
                  <Link to='#' className='custom-link-color d-inline-block fw-medium text-body'>
                    <span className='material-symbols-outlined align-middle font-size-20 me-1'>
                      location_on
                    </span>{' '}
                    Check in
                  </Link>
                </div>
              </li>
              <li className='col-md-6 mb-3'>
                <div className='bg-primary-subtle rounded p-2 pointer me-3'>
                  <Link to='#' className='custom-link-color d-inline-block fw-medium text-body'>
                    <span className='material-symbols-outlined align-middle font-size-20 me-1'>
                      live_tv
                    </span>{' '}
                    Live Video
                  </Link>
                </div>
              </li>
              <li className='col-md-6 mb-3'>
                <div className='bg-primary-subtle rounded p-2 pointer me-3'>
                  <Link to='#' className='custom-link-color d-inline-block fw-medium text-body'>
                    <span className='material-symbols-outlined align-middle font-size-20 me-1'>
                      gif_box
                    </span>{' '}
                    GIF
                  </Link>
                </div>
              </li>
              <li className='col-md-6 mb-3'>
                <div className='bg-primary-subtle rounded p-2 pointer me-3'>
                  <Link to='#' className='custom-link-color d-inline-block fw-medium text-body'>
                    <span className='material-symbols-outlined align-middle font-size-20 me-1'>
                      celebration
                    </span>{' '}
                    Watch Party
                  </Link>
                </div>
              </li>
              <li className='col-md-6 mb-3'>
                <div className='bg-primary-subtle rounded p-2 pointer me-3'>
                  <Link to='#' className='custom-link-color d-inline-block fw-medium text-body'>
                    <span className='material-symbols-outlined align-middle font-size-20 me-1'>
                      sports_esports
                    </span>{' '}
                    Play with Friends
                  </Link>
                </div>
              </li>
            </ul>
            <hr />
            <div className='other-option'>
              <div className='d-flex align-items-center justify-content-between'>
                <div className='d-flex align-items-center'>
                  <div className='user-img me-3'>
                    <img
                      loading='lazy'
                      src={user1}
                      alt='userimg'
                      className='avatar-60 rounded-circle img-fluid'
                    />
                  </div>
                  <h6>Your Story</h6>
                </div>
                <div className='card-post-toolbar'>
                  <Dropdown>
                    <Dropdown.Toggle
                      className='btn btn-primary'
                      data-bs-toggle='dropdown'
                      aria-haspopup='true'
                      aria-expanded='false'
                      role='button'
                    >
                      Friend
                      {/* <span className='btn btn-primary'>Friend</span> */}
                    </Dropdown.Toggle>
                    <Dropdown.Menu className=' m-0 p-0'>
                      <Dropdown.Item className='p-3' href='#'>
                        <div className='d-flex align-items-top'>
                          <span className='material-symbols-outlined'>save</span>
                          <div className='data ms-2'>
                            <h6>Public</h6>
                            <p className='mb-0'>Anyone on or off Facebook</p>
                          </div>
                        </div>
                      </Dropdown.Item>
                      <Dropdown.Item className='p-3' href='#'>
                        <div className='d-flex align-items-top'>
                          <span className='material-symbols-outlined'>cancel</span>
                          <div className='data ms-2'>
                            <h6>Friends</h6>
                            <p className='mb-0'>Your Friend on facebook</p>
                          </div>
                        </div>
                      </Dropdown.Item>
                      <Dropdown.Item className='p-3' href='#'>
                        <div className='d-flex align-items-top'>
                          <span className='material-symbols-outlined'>person_remove</span>
                          <div className='data ms-2'>
                            <h6>Friends except</h6>
                            <p className='mb-0'>Don't show to some friends</p>
                          </div>
                        </div>
                      </Dropdown.Item>
                      <Dropdown.Item className='p-3' href='#'>
                        <div className='d-flex align-items-top'>
                          <span className='material-symbols-outlined'>notifications</span>
                          <div className='data ms-2'>
                            <h6>Only Me</h6>
                            <p className='mb-0'>Only me</p>
                          </div>
                        </div>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
            <Button variant='primary' className='d-block w-100 mt-3'>
              Post
            </Button>
          </Modal.Body>
        </Modal>
      </div>
      <div
        className={`modal-backdrop fade ${show ? 'show' : 'd-none'}`}
        onClick={handleClose}
      ></div>

      {showPicker && (
        <div>
          <EmojiPicker className="w-50" onEmojiClick={handleEmojiSelect} />
        </div>
      )}
    </>
  )
}

export default CreatePost
